if (!customElements.get('klaviyo-back-in-stock')) {
  customElements.define(
    'klaviyo-back-in-stock',
    class KlaviyoBackInStock extends HTMLElement {
      constructor() {
        super();
        this.popup = this.querySelector('[data-popup]');
        this.bisForm = this.querySelector('.klaviyo-bis-required');
        this.closePopupButtons = this.querySelectorAll('[data-close-bis]');
        this.openPopupButton = document.querySelector('[data-open-bis]');
      }

      get sectionId() {
        return this.dataset.sectionId;
      }

      get variantId() {
        return this.dataset.bis;
      }

      connectedCallback() {
        if (!this.bisForm || !this.openPopupButton) return;
        this.openPopupButton.addEventListener('click', () => this.openBis(this.openPopupButton));

        const productForm = document.querySelector(`#product-form-main-${this.sectionId}`);
        productForm.addEventListener('product:rerender', (e) => {
          this.openPopupButton = document.querySelector('[data-open-bis]');
          this.openPopupButton.addEventListener('click', () => this.openBis(this.openPopupButton));
        });

        this.closePopupButtons.forEach(button => {
          button.addEventListener('click', ()=> this.closeBis())
        })

        this.init();
      }
      

      openBis(button) {
        this.dataset.bis = button.dataset.openBis;
        setTimeout(() => {
          this.addVariantTitle();
          this.popup.style.display = 'block';
          this.closePopupButtons.forEach(button => button.classList.add('active'));
        }, 250);
      }

      closeBis() {
        this.popup.style.display = 'none';
        this.removeVariantTitle();
        this.closePopupButtons.forEach(button => button.classList.remove('active'));
      }

      addVariantTitle() {
        const heading = this.bisForm.querySelector('h1');
        if (heading) {
          const varianTitle = `<span class="bis__variant-title">${this.openPopupButton.dataset.title}</span>`;
          heading.insertAdjacentHTML('afterend', varianTitle);
        }
      }

      removeVariantTitle() {
        const variantTitle = this.querySelector('.bis__variant-title');
        if (variantTitle) {
          variantTitle.remove();
        }
      }

      async initBis(email) {
        const url = 'https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=RUuy5Q';
        const payload = {
          data: {
            type: 'back-in-stock-subscription',
            attributes: {
              profile: {
                data: {
                  type: 'profile',
                  attributes: {
                    email: `${email}`,
                  },
                },
              },
              channels: ['EMAIL'],
            },
            relationships: {
              variant: {
                data: {
                  type: 'catalog-variant',
                  id: `$shopify:::$default:::${this.variantId}`,
                },
              },
            },
          },
        };
        const requestOptions = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            revision: '2023-12-15',
          },
          body: JSON.stringify(payload),
        };

        const response = await fetch(url, requestOptions);
        if (response.ok) {
          setTimeout(() => {
            this.closeBis();
          }, 2500);
        }
      }

      init() {
        window.addEventListener('klaviyoForms', async (e) => {
          if (e.detail.type === 'submit' && e.detail.formId === 'WJEaBM') {
            const email = e.detail.metaData.$email;
            await this.initBis(email);
          }
        });
      }
    },
  );
}
